




















































































import Vue from "vue";
import { authentication } from "@/stores";
import firebaseProject from "@/common/firebaseProject";
import { Collection, DocDataRef, DocData, Loading } from "@/stores";
import {
  EventCounter,
  SplashEventCounterWithData,
  getSplashListWithData,
  Splash,
  Tenant
} from "@/models";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { form, autoclose, shopBase } from "@/mixins";
import axios from "axios";
import { alert, confirm } from "@/services/dialog";

const db = firebaseProject.firestore();
export default shopBase.extend(Vue).extend({
  name: "Splash",
  mixins: [],
  data(): {
    authentication: object;
    transitionName: string;
    splashRanking: SplashEventCounterWithData[] | undefined;
    startDate: Date;
    endDate: Date;
    modelConfig: {
      start: {
        timeAdjust: string;
      };
      end: {
        timeAdjust: string;
      };
    };
    lastday: string;
    parPage: number;
    currentPage: number;
  } {
    const nowH = parseInt(dayjs().format("H"));
    let todayD = dayjs();
    if (nowH <= 4) {
      todayD = dayjs().add(-1, "day");
    }
    const alldayStart = todayD.add(-7, "d").format("YYYYMMDD");
    const queryStart = this.$route.query.start
      ? String(this.$route.query.start)
      : alldayStart;
    const queryEnd = this.$route.query.end
      ? String(this.$route.query.end)
      : todayD.add(-1, "d").format("YYYYMMDD");
    return {
      authentication,
      transitionName: "",
      splashRanking: undefined,
      startDate: dayjs(queryStart, "YYYYMMDD").toDate(),
      endDate: dayjs(queryEnd, "YYYYMMDD").toDate(),
      modelConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      lastday: todayD
        .add(-1, "d")
        .startOf("day")
        .format("YYYY-MM-DD"),
      parPage: 10,
      currentPage: 1
    };
  },
  async created() {
    await this.refreshData();
  },
  computed: {
    listItem(): SplashEventCounterWithData[] | [] {
      const current = this.currentPage * this.parPage;
      const start = current - this.parPage;
      return this.splashRanking ? this.splashRanking.slice(start, current) : [];
    },
    getPageCount(): number {
      return this.splashRanking
        ? Math.ceil(this.splashRanking.length / this.parPage)
        : 0;
    },
    total(): number {
      return this.splashRanking?.length || 0;
    },
    pageMax(): number {
      const count = this.currentPage * this.parPage;
      const total = this.total || 0;
      return total < count ? total : count;
    }
  },
  methods: {
    clickPaginate(pageNum: number) {
      this.currentPage = Number(pageNum);
    },
    async refreshData() {
      this.currentPage = 1;
      const nowH = parseInt(dayjs().format("H"));
      let todayD = dayjs();
      if (nowH <= 4) {
        todayD = dayjs().add(-1, "day");
      }
      const alldayStart = todayD.add(-7, "d").format("YYYYMMDD");
      const dateStart = this.$route.query.start || alldayStart;
      const dateEnd =
        this.$route.query.end || todayD.add(-1, "d").format("YYYYMMDD");
      const idToken = await firebaseProject.auth().currentUser?.getIdToken();
      if (!idToken) {
        //エラー
      }
      const baseHost = "/api";
      const eventUrl = baseHost + `/analytics/event`;
      const eventData = await axios.get(eventUrl, {
        headers: { Authorization: idToken },
        params: {
          shopId: this.$config.shopId,
          eventStart: dateStart,
          eventEnd: dateEnd
        }
      });
      const splashData = await db
        .collection("/splash")
        .where("shopId", "==", this.shopId)
        .get()
        .then(snapshot => {
          return snapshot.docs.map(doc => {
            return new DocDataRef({
              document: doc.data() as Splash,
              id: doc.id,
              ref: doc.ref
            } as DocData<Splash>);
          });
        });
      const tenantData = await db
        .collection("tenant")
        .where("shopId", "==", this.shopId)
        .get()
        .then(snapshot => {
          return snapshot.docs.map(doc => {
            return new DocDataRef({
              document: doc.data() as Tenant,
              id: doc.id,
              ref: doc.ref
            } as DocData<Tenant>);
          });
        });
      const newData = getSplashListWithData(
        eventData.data.countData || [],
        splashData || [],
        tenantData || []
      );
      this.splashRanking = [...newData];
    },
    async changeDate() {
      const start = dayjs(this.startDate).format("YYYYMMDD");
      const end = dayjs(this.endDate).format("YYYYMMDD");
      if (start > end) {
        alert({
          title: "エラー",
          text: "期間を正しく選択してください。"
        });
      }
      // 期間エラーの場合もデータの更新は行う→0件になる
      this.$router.replace({
        query: { start: String(start), end: String(end) }
      });
      await this.refreshData();
    }
  }
});
